import 'antd/dist/antd.css';
import axios from '../../utils/request';
import React, { Component, Route, Redirect} from "react";
import { Spinner } from 'reactstrap';
import { Result } from 'antd';

export class Starbucks_BPMHiringApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            errorMessage: "",
            link: "",
            tenantId: "",
            userId: "",
            commonParamater: "",
            applyId: "",
            applicantId: ""
        }
    };

    componentDidMount() {
        //this.loadPage(null, null, null, null, null);
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");

        //if (!commonParamater) {
        //    this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
        //    return;
        //}
        this.state.commonParamater = commonParamater;
        this.loadPage(commonParamater);

        window.addEventListener('pageshow', function (event) {
            console.log('after , pageshow :', event);
        });
    };

    loadPage = (commonParamater) => {
        const params = {
            commonParamater
        }
        axios
            .get("/api/stb/BPMHiring/HiringApply", { params: params })
            .then(res => {
                let errorMessage=""
                window.location.href = res.data.data
                this.setState({ isLoading: false, isReady: true, errorMessage: errorMessage });
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
            );
    };

    render() {
        return (
            <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="secondary" />
                <Spinner type="grow" color="success" />
                <Spinner type="grow" color="danger" />
                <Spinner type="grow" color="warning" />
                <Spinner type="grow" color="info" />
                <Spinner type="grow" color="dark" />
            </div>
        );
    }
}